import { defineMessages } from 'react-intl';

export default defineMessages({
	backButtonLabel: {
		id: 'guideLayout.backButtonLabel',
		defaultMessage: 'Return to previous screen',
		description: 'A button label that minimizes the player',
	},
});
